// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"f1f6d395","262":"2d8047f9","761":"bf9ac3e9"}[chunkId] + ".chunk.css";
};